<div class="fullscreen-dialog">
  <h3 class="textcolorh1">
    {{ config }}&nbsp;{{
      'setup.storage-config.configuration-change-overlay.title' | translate
    }}
  </h3>

  <div class="textcolor">
    {{
      'setup.storage-config.configuration-change-overlay.subtitle' | translate
    }}
  </div>
  <div mat-dialog-actions class="mt-3 justify-content-center">
    <button
      data-testid="drive_config_change_overlay_btn_refresh"
      mat-flat-button
      color="primary"
      (click)="onClickRefresh()"
    >
      <div class="textcolor">
        {{
          'setup.storage-config.configuration-change-overlay.refresh-button'
            | translate
        }}
      </div>
    </button>
  </div>
</div>
